export function getCurrentMonthInput(): string {
  const now = new Date()
  const y = now.getUTCFullYear()
  const m = String(now.getUTCMonth() + 1).padStart(2, '0')
  return `${y}-${m}`
}

export function monthInputToMonthStartDate(monthInput: string): string {
  const raw = String(monthInput || '').trim()
  const m = /^(\d{4})-(\d{2})$/.exec(raw)
  if (!m) throw new Error('Mes invalido')
  const year = Number(m[1])
  const month = Number(m[2])
  if (!Number.isFinite(year) || !Number.isFinite(month) || month < 1 || month > 12) throw new Error('Mes invalido')
  return new Date(Date.UTC(year, month - 1, 1)).toISOString().slice(0, 10)
}

export function monthStartDateToLabel(monthStartDate: string): string {
  const d = new Date(`${monthStartDate}T00:00:00.000Z`)
  if (!Number.isFinite(d.getTime())) return monthStartDate
  const m = String(d.getUTCMonth() + 1).padStart(2, '0')
  const y = d.getUTCFullYear()
  return `${m}/${y}`
}

